import { useField } from 'formik'
import { Form } from 'semantic-ui-react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import React, { useEffect, useRef, useState } from 'react'
import FWOLabel from './FWOLabel'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'

const FWODateInput = (props: Partial<ReactDatePickerProps>) => {
  const mountedRef = useRef(false)
  const [field, meta, helpers] = useField(props.name)
  const [date, setDate] = useState(null)
  const format = 'DD/MM/YYYY'

  useEffect(() => {
    mountedRef.current = true
    if (field.value) {
      let date
      if (isNaN(Date.parse(field.value))) {
        const arr = field.value.split('/') //Date parse doesn't work without timestamp.
        date = moment(new Date(arr[2], arr[1], arr[0], 0, 0, 0)).add(
          -1,
          'months'
        )
      } else {
        const dt = new Date(field.value)
        date = moment(
          new Date(dt.getFullYear(), dt.getMonth() + 1, dt.getDate(), 0, 0, 0)
        ).add(-1, 'months')
      }

      if (mountedRef.current) {
        setDate(date.toDate())
        helpers.setValue(date.format(format).toString())
      }
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  return (
    <Form.Field
      error={
        (meta.touched || (field.value === null && field.value === '')) &&
        !!meta.error
      }
      {...{ required: props.required }}
    >
      <div className={`sixteen wide field`}>
        <FWOLabel
          label={props.label}
          name={props.name}
          tooltip={props.tooltip}
          showOptional={props.showOptional}
          required={props.required}
          htmlTooltip={props.htmlTooltip}
          defaultHtmlTooltipIconText={props.defaultHtmlTooltipIconText}
        />
        {meta.touched &&
        (field.value === null || field.value === '') &&
        meta.error ? (
          <span className="validation-error">{meta.error}</span>
        ) : null}
        <DatePicker
          dateFormat="dd/MM/yyyy"
          placeholderText="dd/mm/yyyy"
          type={props.type}
          {...props}
          selected={date}
          onChange={(value) => {
            if (value === null) {
              setDate(null)
              helpers.setValue('')
              return
            }
            const date = moment(Date.parse(value))
            setDate(date.toDate())
            helpers.setValue(date.format(format).toString())
          }}
          {...{ readOnly: props.showreadonly == true }}
        />
      </div>
    </Form.Field>
  )
}

export default FWODateInput
